import { render, staticRenderFns } from "./marketing-record-dialog.vue?vue&type=template&id=0fc66ef6&scoped=true"
import script from "./marketing-record-dialog.vue?vue&type=script&lang=js"
export * from "./marketing-record-dialog.vue?vue&type=script&lang=js"
import style0 from "./marketing-record-dialog.vue?vue&type=style&index=0&id=0fc66ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc66ef6",
  null
  
)

export default component.exports